export default __webpack_public_path__ + "static/media/moodsDayImageActive.fb6f22c4.svg";